import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M2.7 3.7h10.6v7.863H8l-3.312 2.01v-2.01H2.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 3.7a.7.7 0 0 1 .7-.7h10.6a.7.7 0 0 1 .7.7v7.863a.7.7 0 0 1-.7.7H8.196l-3.145 1.91a.7.7 0 0 1-1.064-.599v-1.312H2.7a.7.7 0 0 1-.7-.7zm1.4.7v6.463h1.288a.7.7 0 0 1 .7.7v.767l2.249-1.366A.7.7 0 0 1 8 10.863h4.6V4.4z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=MessageIcon16.js.map